import { api } from "..";

const endpoint = "/api/catalogues";

// GET
export const getCatalogue = (queryParams: any) => {
  return api.get(`${endpoint}`, { params: queryParams });
};

export const getCatalogueEntryById = (id: string) => {
  return api.get(`${endpoint}/${id}`);
};

export const getCatalogueByCode = (code: string) => {
  return api.get(`${endpoint}/by-code/${code}`);
};

// POST
export const addCatalogueEntry = (data: any) => {
  return api.post(`${endpoint}`, data);
};

// PUT
export const updateCatalogueEntry = (id: string, data: any) => {
  return api.put(`${endpoint}/${id}`, data);
};

// DELETE
export const deleteCatalogueEntry = (id: string) => {
  return api.delete(`${endpoint}/${id}`);
};

// TAX REGIME
export const getTaxRegimeList = (queryParams: any) => {
  return api.get(`${endpoint}/tax-regime/`, { params: queryParams });
};

export const addTaxRegime = (data: any) => {
  return api.post(`${endpoint}/tax-regime/`, data);
};

export const updateTaxRegime = (id: string, data: any) => {
  return api.put(`${endpoint}/tax-regime/${id}`, data);
};

export const deleteTaxRegime = (id: string) => {
  return api.delete(`${endpoint}/tax-regime/${id}`);
};

// ADRESSES
export const addAddress = (data: any) => {
  return api.post(`/api/addresses/`, data);
};

export const getAddressById = (id: string) => {
  return api.get(`/api/addresses/${id}`);
};

export const updateAddress = (id: string, data: any) => {
  return api.put(`/api/addresses/${id}`, data);
};

export const deleteAddress = (id: string) => {
  return api.delete(`/api/addresses/${id}`);
};

// STATUS CATALOGUES
export const getStatusCatalogue = (CatalogueName: string) => {
  return api.get(`${endpoint}/status`, { params: { CatalogueName } });
};

export const addStatus = (data: any) => {
  return api.post(`${endpoint}/status`, data);
};

export const updateStatus = (id: string, data: any) => {
  return api.put(`${endpoint}/status/${id}`, data);
};

export const deleteStatus = (id: string) => {
  return api.delete(`${endpoint}/status/${id}`);
}; 